import { render } from "./CookieModal.vue?vue&type=template&id=72f650e6"
import script from "./CookieModal.vue?vue&type=script&lang=js"
export * from "./CookieModal.vue?vue&type=script&lang=js"

import "./CookieModal.vue?vue&type=style&index=0&id=72f650e6&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__